import { Handle, Position } from 'reactflow';
import {IMAGE_BASE_URL} from '../../config'
const EmployeeNode = ({ data }) => {
  const { employee, isEditMode, onAddChild, onDelete } = data;

  return (
    <div style={{
      background: '#3d52a0;',
      backdropFilter: 'blur(20px)',
      WebkitBackdropFilter: 'blur(20px)',
      border: '1px solid #adbbda',
      borderRadius: '16px',
      padding: '20px',
      width: '220px',
      boxShadow: '0 4px 16px #586182ff, inset 0 1px 1px #bdc8e1ff',
      textAlign: 'center',
      fontFamily: 'system-ui, -apple-system, sans-serif',
      position: 'relative',
      transition: 'all 0.3s ease'
    }}>
      <Handle
        type="target"
        position={Position.Top}
        style={{
          width: '8px',
          height: '8px',
          background: 'rgba(255, 255, 255, 0.3)',
          backdropFilter: 'blur(10px)',
          border: '2px solid rgba(255, 255, 255, 0.5)',
          borderRadius: '50%',
          // top: '-12px',
          left: '50%',
          transform: 'translateX(-50%)',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          zIndex: 10,
          opacity: isEditMode ? 1 : 0,
          pointerEvents: isEditMode ? 'auto' : 'none',
        }}
      />
      <Handle
        type="source"
        position={Position.Bottom}
        style={{
          width: '8px',
          height: '8px',
          background: 'rgba(255, 255, 255, 0.3)',
          backdropFilter: 'blur(10px)',
          border: '2px solid rgba(255, 255, 255, 0.5)',
          borderRadius: '50%',
          // bottom: '-12px',
          left: '50%',
          transform: 'translateX(-50%)',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          zIndex: 10,
          opacity: isEditMode ? 1 : 0,
          pointerEvents: isEditMode ? 'auto' : 'none',
        }}
      />
      
      {/* Avatar Circle */}
      <div style={{
        width: '60px',
        height: '60px',
        borderRadius: '50%',
        background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.8) 0%, rgba(118, 75, 162, 0.8) 100%)',
        margin: '0 auto 12px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '24px',
        fontWeight: '700',
        color: 'white',
        border: '3px solid rgba(255, 255, 255, 0.3)',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        overflow:'hidden'
      }}>
        { employee.image? (<img 
          src={employee.image ? `${IMAGE_BASE_URL}${employee.image}` : ""}
          alt={`${employee.firstName} ${employee.lastName}`}
          width={'58px'}
          height={'58px'}
          onError={(e) => {
            e.target.style.display = 'none';
          }}
        />) :
        <div className="avatar-fallback">
          {employee.firstName?.[0]}{employee.lastName?.[0]}
        </div>
        }
      </div>

      {/* Department Badge */}
      {/* <div style={{ 
        fontSize: '11px', 
        fontWeight: '600', 
        marginBottom: '8px',
        color: '#667eea',
        textTransform: 'uppercase',
        letterSpacing: '1px',
        background: 'rgba(102, 126, 234, 0.15)',
        padding: '4px 10px',
        borderRadius: '12px',
        display: 'inline-block',
        border: '1px solid rgba(102, 126, 234, 0.3)'
      }}>
        {employee.department?.name || 'No Dept'}
      </div> */}
      
      <div style={{ 
        fontSize: '18px', 
        fontWeight: '700',
        marginBottom: '4px',
        color: '#1f2937',
        textShadow: '0 1px 2px rgba(255, 255, 255, 0.5)'
      }}>
        {employee.firstName} {employee.lastName}
      </div>
      
      <div style={{ 
        fontSize: '14px', 
        fontWeight: '500',
        marginBottom: '10px',
        color: '#4b5563'
      }}>
        {employee.position ? [...new Set(employee.position.split(';').map(p => p.trim()).filter(p => p))].join('; ') : 'N/A'}
      </div>
      
      <div style={{ 
        fontSize: '12px',
        color: '#6b7280',
        background: 'rgba(255, 255, 255, 0.5)',
        padding: '6px 12px',
        borderRadius: '8px',
        display: 'inline-block',
        border: '1px solid rgba(255, 255, 255, 0.6)'
      }}>
        📍 {employee.office?.name}
      </div>

      {isEditMode && (
        <div style={{
          marginTop: '14px',
          display: 'flex',
          gap: '8px',
          justifyContent: 'center'
        }}>
          <button
            onClick={(e) => {
              e.stopPropagation();
              onAddChild(employee.employeeId);
            }}
            style={{
              padding: '8px 14px',
              background: 'rgba(16, 185, 129, 0.9)',
              backdropFilter: 'blur(10px)',
              color: 'white',
              border: '1px solid rgba(255, 255, 255, 0.3)',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '13px',
              fontWeight: '600',
              boxShadow: '0 4px 12px rgba(16, 185, 129, 0.3)',
              transition: 'all 0.2s'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 6px 16px rgba(16, 185, 129, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 12px rgba(16, 185, 129, 0.3)';
            }}
          >
            ➕ Add
          </button>
          <button
            onClick={(e) => {
              e.stopPropagation();
              onDelete(employee.employeeId);
            }}
            style={{
              padding: '8px 14px',
              background: 'rgba(239, 68, 68, 0.9)',
              backdropFilter: 'blur(10px)',
              color: 'white',
              border: '1px solid rgba(255, 255, 255, 0.3)',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '13px',
              fontWeight: '600',
              boxShadow: '0 4px 12px rgba(239, 68, 68, 0.3)',
              transition: 'all 0.2s'
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 6px 16px rgba(239, 68, 68, 0.4)';
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 12px rgba(239, 68, 68, 0.3)';
            }}
          >
            🗑️
          </button>
        </div>
      )}
    </div>
  );
};
export default EmployeeNode;